import { createSelector } from 'reselect'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'
import Config from 'constants/config'

export const isTourPromoSpendEarnEnabled = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (regionCode): boolean => Config.TOUR_SPEND_EARN_BANNER && isEnabledForFeature(Config.TOUR_SPEND_EARN_BANNER_REGIONS, regionCode),
)
